import CustomCard from "../../CustomCard";
import {CustomCheckbox} from "../../CustomCheckbox";
import {
    IconCheckboxChecked,
    IconCheckboxUnchecked,
    IconCloseChip, IconDepartment,
    PersonOutlinedChip
} from "../../buttons/IconButtons";
import CustomTooltip from "../../CustomTooltip";
import React from "react";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 04 de 05 de 2026
 */

const SelectedDepartmentTotalEmployeesCard = (
    {
        keyId,
        item,
        onDelete,
        handleCheckboxChange
    }
) => {

    return (
        <CustomCard
            classes="w-100"
            classCard="card-border-8px"
            classContent={`background-shades-50`}
        >
            <div className="row">
                <div className={"d-flex justify-content-between p-0"}>
                    { handleCheckboxChange &&
                    <div className={"align-top mr-3"}>
                        <CustomCheckbox
                            id={'cb_sue_row_' + keyId}
                            checked={item?.checked}
                            onChange={(e) => {
                                handleCheckboxChange({
                                    target: {
                                        [keyId]: item[keyId],
                                        checked: e.target.checked,
                                    },
                                });
                            }}
                            disabled={item?.disabled}
                            icon={<IconCheckboxUnchecked className={"icon-color-general-950"}/>}
                            checkedIcon={<IconCheckboxChecked className={"icon-color-shades-800"}/>}
                            disableRipple={true}
                        />
                    </div>
                    }

                    <div className={"flex-grow-1 minw-0 mr-1 mt-2"}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className={`col-12 p-0`}>
                                <div className='d-flex align-items-center justify-content-start'>
                                    <div><IconDepartment className="mr-8px mb-1" /></div>
                                    <div className={`mr-5 flex-grow-1 minw-0 p-0`}>
                                        <CustomTooltip
                                            text={item?.fullName}
                                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                    { onDelete &&
                                    <div className={"position-absolute r-0px t-negative-4px"}>
                                        <IconCloseChip
                                            className='icon-color-shades-400 icon-hover-shades-950'
                                            onClick={() => onDelete(item)}
                                        />
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="border-bottom-shades-300 my-2" />

                        <div className='d-flex align-items-center justify-content-between '>
                            <div className={'col-12 pl-0'}>
                                <div className="d-flex align-items-center">
                                    <div><PersonOutlinedChip className="mr-8px mb-1" /></div>
                                    <div className={"minw-0"}>
                                        <CustomTooltip
                                            text={item?.totalEmployees}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CustomCard>
    );
}
export default SelectedDepartmentTotalEmployeesCard
